export const ApiResultStatus = {
  SUCCESS: 0,
  ERROR: 1
};

export const MfaNotificationMethod = {
  EMAIL: 0,
  SMS: 1
};

export const DaysOfWeek = {
  NONE: 0,
  SUNDAY: 1,
  MONDAY: 2,
  TUESDAY: 4,
  WEDNESDAY: 8,
  THURSDAY: 16,
  FRIDAY: 32,
  SATURDAY: 64
};

export const Menu = {
  NONE: 0,
  SIDEBAR: 1,
  PROFILE: 2
};

export enum LoginView {
  LOGIN = 0,
  MFA = 1
}

export enum LoginStatus {
  FAILED = 0,
  SUCCESS = 1,
  LOCKED_OUT = 2,
  INACTIVE = 3,
  MFA_REQUIRED = 4,
  MFA_LOCKED_OUT = 5
}

export enum MfaValidationResult {
  FAILED = 0,
  FAILED_INVALID_TOKEN = 1,
  FAILED_CODE_EXPIRED = 2,
  FAILED_LOCKED_OUT = 3,
  SUCCESSFUL = 4
}

export const LogoutReason = {
  TIMED_OUT: 0
};

export enum ApiResult {
  UNKNOWN = 0,
  SUCCESS = 1,
  FAILED = 2
}
export enum ImportModalOptions {
  NONE = 0,
  HIDE_SUCCESS_ONLY_VALIDATION_RESULTS = 1,
  HIDE_SUCCESS_ONLY_IMPORT_RESULTS = 2,
  HIDE_DOWNLOAD_RESULT_LINK = 4
}

export enum AdvancedSortViewMode {
  DEFAULT = 0,
  MODAL = 1
}

export enum SortDirection {
  ASCENDING = 1,
  DESCENDING = 2
}

export enum ImportStatus {
  UNKNOWN = 0,
  VALIDATION_COMPLETE = 1,
  VALIDATION_FAILED = 2,
  IMPORT_QUEUED = 3,
  IMPORT_RUNNING = 4,
  IMPORT_COMPLETE = 5,
  IMPORT_FAILED = 6
}

export enum RowResultStatus {
  NONE = 0,
  SUCCESS = 1,
  WARNING = 2,
  ERROR = 3
}

export enum UserLookupDisplayMode {
  DEFAULT = 0,
  SIMPLE = 1
}

export enum ClubMemberLookupDisplayMode {
  DEFAULT = 0,
  SIMPLE = 1
}

export enum MemberTitle {
  None = 0,
  Mr = 1,
  Mrs = 2,
  Ms = 3,
  Dr = 4
}

export enum MemberSuffix {
  None = 0,
  I = 1,
  II = 2,
  III = 3,
  IV = 4,
  MD = 5,
  Dr = 6,
  Jr = 7,
  Sr = 8
}

export enum MemberStatus {
  NewCandidate = 1,
  Active = 2,
  Inactive = 3,
  LeaveOfAbsence = 4,
  Delete = 5,
  Resigned = 6,
  Suspended = 7,
  Expelled = 8
}

export enum FamilyMemberType {
  None = 0,
  Adult = 1,
  Child = 2
}

export enum MembershipTypeCategory {
  STANDARD = 0,
  MILITARY = 1,
  MILITARY_FAMILY = 2,
  FAMILY_PRIMARY = 3,
  SENIOR = 4
}

export enum MembershipTypeClass {
  PROVISIONAL = 0,
  REGULAR = 1,
  HONORARY = 2,
  LIFE = 3
}

export enum PaymentMethod {
  NONE = 0,
  CASH = 1,
  CHECK = 2,
  CREDIT_CARD = 3,
  MONEY_ORDER = 4,
  WEBSITE = 5
}

export enum PaymentStatus {
  Pending = 0,
  Completed = 1,
  Failed = 2,
  Cancelled = 3,
  Refunded = 4
}

export enum LateFeeStatus {
  NoLateFees = 0,
  FirstLateFee = 1,
  SecondLateFee = 2,
  DeadlinePassed = 3
}
